/**
 * Responsive Background Images Utility
 */
class ResponsiveBackgroundImage {
  constructor(element) {
    this.element = element;
    this.img = element.querySelector('[data-responsive-background-image]');
    this.src = '';

    if (this.img) {
      this.img.addEventListener('load', () => {
        this.update();
      });

      if (this.img.complete) {
        this.update();
      }
    }
  }

  update() {
    let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
    if (this.src !== src) {
      this.src = src;
      this.element.style.backgroundImage = 'url("' + this.src + '")';
    }
  }
}

function responsiveBackgroundImages() {
  const responsiveBackgroundElements = document.querySelectorAll('[data-responsive-background]');

  for (let i = 0; i < responsiveBackgroundElements.length; i++) {
    new ResponsiveBackgroundImage(responsiveBackgroundElements[i]);
  }
}

responsiveBackgroundImages()

export { responsiveBackgroundImages };
